<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Business Case DashBoard</h1>
            </div>

            <div class="businesscase_header">
                <div class="dropdown" style="margin: 10px 0px;">
                    <p-dropdown autoWidth="false" [options]="sourceDropdownOptions" [(ngModel)]="selectedSource"
                        (onChange)="onDropdownChange()">
                    </p-dropdown>
                </div>

                <div class="refreshButton">
                    <button class="btn btn-primary" (click)="refreshData()">Refresh</button>
                </div>
            </div>

            <!-- <div style="margin-bottom: 20px;">
                <a routerLink="/errordashboard" class="link-card">Back</a>
            </div> -->

            <div class="card">
                <p-table *ngIf="selectedSource === 'Sales> 100 Mn and Sales = 0'" [value]="businessLogData"
                    [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>Businesscase/Costing</th>
                            <th pSortableColumn="Revenue">Revenue <p-sortIcon field="Revenue"></p-sortIcon></th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>
                                <span *ngIf="rowData['Businesscase Bool'] === true">Business Case</span>
                                <span *ngIf="rowData['Costing Bool'] === true">Costing</span>
                            </td>

                            <td>{{ rowData['Revenue'] }}</td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToBusinesscasePage(rowData['Brand Name'],rowData['NDA number'],rowData['Dosage forms'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>

                <p-table *ngIf="selectedSource === 'IRR = 0'" [value]="irrData" [tableStyle]="{'min-width': '60rem'}"
                    [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>Businesscase/Costing</th>
                            <th>IRR</th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>
                                <span *ngIf="rowData['Businesscase Bool'] === true">Business Case</span>
                                <span *ngIf="rowData['Costing Bool'] === true">Costing</span>
                            </td>

                            <td>{{ rowData['IRR'] }}</td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToIrrPage(rowData['Brand Name'],rowData['NDA number'],rowData['Dosage forms'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>

                <p-table *ngIf="selectedSource === 'NPV+ and IRR-'" [value]="irrNpvData"
                    [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>IRR</th>
                            <th>NPV</th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>{{ rowData['IRR'] }}</td>
                            <td>{{ rowData['NPV'] }}</td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToIrrNpvPage(rowData['Brand Name'],rowData['NDA number'],rowData['Dosage forms'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>

                <p-table *ngIf="selectedSource === 'IRR > 100%'" [value]="irrGreaterhundred"
                    [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>IRR</th>
                            <th>NPV</th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>{{ rowData['IRR'] }}</td>
                            <td>{{ rowData['NPV'] }}</td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToIrrNpvPage(rowData['Brand Name'],rowData['NDA number'],rowData['Dosage forms'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>

                <p-table *ngIf="selectedSource === 'MFD = Genericized and IRR > 25%'" [value]="irrGreatertwentyfive"
                    [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>IRR</th>
                            <th>NPV</th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>{{ rowData['IRR'] }}</td>
                            <td>{{ rowData['NPV'] }}</td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToIrrNpvPage(rowData['Brand Name'],rowData['NDA number'],rowData['Dosage forms'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>